import { useState } from 'react'
import styles from './FormSection.module.scss'

const API_PREFIX = process.env.REACT_APP_API_URL || 'http://localhost:8000';

function ResultModal({ type, message, onClose }) {
	return (
		<div className={styles.modalOverlay} onClick={onClose}>
			<div
				className={`${styles.resultModal} ${type === 'success' ? styles.modalSuccess : styles.modalError
					}`}
				onClick={(e) => e.stopPropagation()}
			>
				<button className={styles.modalClose} onClick={onClose}>
					×
				</button>
				<div className={styles.modalIconWrapper}>
					{type === 'success' ? (
						<div className={styles.successIcon}>✔️</div>
					) : (
						<img
							src='/img/icons/cross-red.svg'
							alt='Ошибка'
							className={styles.modalIcon}
						/>
					)}
				</div>
				<div className={styles.modalMessage}>{message}</div>
				<button className={styles.modalSubmitBtn} onClick={onClose}>
					Закрыть
				</button>
			</div>
		</div>
	)
}

export default function FormSection() {
	const [form, setForm] = useState({
		parentName: '',
		childName: '',
		childAge: '',
		direction: '',
		phone: '',
		agreed: false,
	})
	const [errors, setErrors] = useState({})
	const [sending, setSending] = useState(false)
	const [modal, setModal] = useState({ open: false, type: '', message: '' })

	const directions = [
		'Консультация',
		'Программирование',
		'Робототехника',
		'3D-моделирование',
		'Создание сайтов',
		'Ментальная арифметика',
		'Скорочтение',
		'Каллиграфия',
		'IT-лагерь',
	]

	const handleChange = (e) => {
		const { name, value, type, checked } = e.target
		let newValue = type === 'checkbox' ? checked : value
		if (name === 'childAge') {
			newValue = String(newValue).replace(/\D/g, '')
			if (newValue.length > 2) newValue = newValue.slice(0, 2)
		}
		setForm((prev) => ({
			...prev,
			[name]: newValue,
		}))
		if (errors[name]) {
			setErrors((prev) => ({ ...prev, [name]: '' }))
		}
	}

	const handlePhoneChange = (e) => {
		let input = e.target.value.replace(/\D/g, '')
		if (input.startsWith('7')) input = input.slice(1)
		if (input.length > 10) input = input.slice(0, 10)
		let formatted = '+7 '
		if (input.length > 0) formatted += '(' + input.substring(0, 3)
		if (input.length >= 4) formatted += ') ' + input.substring(3, 6)
		if (input.length >= 7) formatted += '-' + input.substring(6, 8)
		if (input.length >= 9) formatted += '-' + input.substring(8, 10)
		setForm((prev) => ({
			...prev,
			phone: formatted,
		}))
		if (errors.phone) {
			setErrors((prev) => ({ ...prev, phone: '' }))
		}
	}

	const validate = () => {
		const newErrors = {}
		if (!form.parentName.trim()) newErrors.parentName = 'Введите ваше имя'
		if (!form.childName.trim()) newErrors.childName = 'Введите имя ребенка'
		if (!form.childAge.trim()) {
			newErrors.childAge = 'Введите возраст ребенка'
		} else {
			const age = Number(form.childAge)
			if (Number.isNaN(age)) {
				newErrors.childAge = 'Возраст должен быть числом'
			} else if (age < 3 || age > 18) {
				newErrors.childAge = 'Возраст должен быть от 3 до 18 лет'
			}
		}
		if (!form.direction.trim()) newErrors.direction = 'Выберите направление'
		if (!form.phone.trim()) newErrors.phone = 'Введите номер телефона'
		else {
			const digits = form.phone.replace(/\D/g, '')
			if (digits.length !== 11) newErrors.phone = 'Неверный формат телефона'
		}
		if (!form.agreed) newErrors.agreed = 'Необходимо согласие'
		return newErrors
	}

	const handleSubmit = async (e) => {
		e.preventDefault()
		const formErrors = validate()
		if (Object.keys(formErrors).length > 0) {
			setErrors(formErrors)
			return
		}
		setErrors({})
		setSending(true)
		try {
			const payload = {
				parentName: form.parentName.trim(),
				childName: form.childName.trim(),
				childAge: form.childAge.trim(),
				direction: form.direction,
				phone: form.phone.replace(/\D/g, ''),
				createdAt: new Date().toISOString(),
			}
			const response = await fetch(`${API_PREFIX}/api/send_email_message`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(payload),
			})
			if (!response.ok)
				throw new Error('Ошибка при отправке. Попробуйте позже.')
			setModal({
				open: true,
				type: 'success',
				message:
					'Спасибо! Ваша заявка отправлена. Мы свяжемся с вами в ближайшее время.',
			})
			setForm({
				parentName: '',
				childName: '',
				childAge: '',
				direction: '',
				phone: '',
				agreed: false,
			})
		} catch (error) {
			setModal({
				open: true,
				type: 'error',
				message: error.message || 'Что-то пошло не так. Попробуйте позже.',
			})
		}
		setSending(false)
	}

	const handlePrivacyClick = (e) => {
		e.preventDefault()
		const link = document.createElement('a')
		link.href = '/files/privacy-policy.pdf'
		link.download = 'Политика_конфиденциальности.pdf'
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
	}

	return (
		<section id='form-section' className={styles.FormSectionWrapper}>
			{modal.open && (
				<ResultModal
					type={modal.type}
					message={modal.message}
					onClose={() => setModal({ open: false, type: '', message: '' })}
				/>
			)}
			<div className={styles.left}>
				<form onSubmit={handleSubmit} className={styles.form} noValidate>
					<div className={styles.inputRow}>
						<div className={styles.inputContainer}>
							<input
								type='text'
								name='parentName'
								placeholder='Ваше имя'
								value={form.parentName}
								onChange={handleChange}
								className={errors.parentName ? styles.error : ''}
								required
							/>
							{errors.parentName && (
								<p className={styles.errorMessage}>{errors.parentName}</p>
							)}
						</div>
						<div className={styles.inputContainer}>
							<input
								type='text'
								name='childName'
								placeholder='Имя ребенка'
								value={form.childName}
								onChange={handleChange}
								className={errors.childName ? styles.error : ''}
								required
							/>
							{errors.childName && (
								<p className={styles.errorMessage}>{errors.childName}</p>
							)}
						</div>
					</div>

					<div className={styles.inputRow}>
						<div className={styles.inputContainer}>
							<input
								type='text'
								name='childAge'
								placeholder='Возраст ребенка'
								value={form.childAge}
								onChange={handleChange}
								inputMode='numeric'
								pattern='\d*'
								className={errors.childAge ? styles.error : ''}
								required
							/>
							{errors.childAge && (
								<p className={styles.errorMessage}>{errors.childAge}</p>
							)}
						</div>
						<div className={styles.inputContainer}>
							<select
								name='direction'
								value={form.direction}
								onChange={handleChange}
								className={`${styles.select} ${errors.direction ? styles.error : ''
									}`}
								required
							>
								<option value='' disabled>
									{form.direction || 'Направление'}
								</option>
								{directions.map((dir) => (
									<option key={dir} value={dir}>
										{dir}
									</option>
								))}
							</select>
							{errors.direction && (
								<p className={styles.errorMessage}>{errors.direction}</p>
							)}
						</div>
					</div>

					<div className={`${styles.inputRow} ${styles.single}`}>
						<div className={styles.inputContainer}>
							<input
								type='tel'
								name='phone'
								placeholder='+7 (___) ___-__-__'
								value={form.phone}
								onChange={handlePhoneChange}
								className={errors.phone ? styles.error : ''}
								required
							/>
							{errors.phone && (
								<p className={styles.errorMessage}>{errors.phone}</p>
							)}
						</div>
					</div>

					<div className={styles.checkboxContainer}>
						<label className={styles.checkboxLabel}>
							<input
								type='checkbox'
								name='agreed'
								checked={form.agreed}
								onChange={handleChange}
								required
							/>
							<span className={styles.customCheckbox} />
							<span>
								Я согласен на обработку моих данных и ознакомлен с{' '}
								<a href='#' onClick={handlePrivacyClick}>
									Политикой конфиденциальности
								</a>
							</span>
						</label>
						{errors.agreed && (
							<p className={styles.errorMessage}>{errors.agreed}</p>
						)}
					</div>

					<button type='submit' className={styles.submitBtn} disabled={sending}>
						{sending ? 'Отправка...' : 'Оставить заявку'}
					</button>
				</form>
			</div>
			<div className={styles.right}>
				<div className={styles.rightHeadText}>
					<h2>Откроем вашему ребенку мир IT</h2>
					<p>Запишитесь на бесплатное пробное занятие</p>
				</div>
				<img
					src='/img/stock/illustration.png'
					alt='Иллюстрация ребенка за компьютером'
				/>
			</div>
		</section>
	)
}
